export default "__VITE_ASSET__Cpp$b60C__"